// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Z6-z"};